import { Box, Slider, Typography } from '@material-ui/core'

import { RangeFilterValue } from 'routes/highschools/utils/filter-utils'

import { PremiumWrapper } from '../PremiumPreview/PremiumWrapper'

type FilterDemographicsProps = {
  pctFirstGenerationStudents?: RangeFilterValue
  pctWhiteCaucasianStudents?: RangeFilterValue
  pctBlackAfricanAmericanStudents?: RangeFilterValue
  pctHispanicLatinoStudents?: RangeFilterValue
  pctAsianStudents?: RangeFilterValue
  pctNativeAmericanStudents?: RangeFilterValue
  pctOtherUndisclosedStudents?: RangeFilterValue
  onChange: (
    formState: Partial<{
      pctFirstGenerationStudents: RangeFilterValue
      pctWhiteCaucasianStudents: RangeFilterValue
      pctBlackAfricanAmericanStudents: RangeFilterValue
      pctHispanicLatinoStudents: RangeFilterValue
      pctAsianStudents: RangeFilterValue
      pctNativeAmericanStudents: RangeFilterValue
      pctOtherUndisclosedStudents: RangeFilterValue
    }>,
  ) => void
  enabled: boolean
}

type DemographicSliderProps = {
  label: string
  value?: RangeFilterValue
  ariaLabel: string
  fieldName: keyof FilterDemographicsProps
  onChange: (fieldName: keyof FilterDemographicsProps, value: RangeFilterValue) => void
  enabled: boolean
}

const DemographicSlider = ({ label, ariaLabel, value, fieldName, onChange, enabled }: DemographicSliderProps) => (
  <Box
    display="flex"
    flexDirection="column"
    gridGap={16}
  >
    <Typography variant="body2">{label}</Typography>
    <Box
      pl={1}
      pr={2}
    >
      <Slider
        disabled={!enabled}
        value={[value?.min || 0, value?.max || 100]}
        onChange={(_, sliderValue) => {
          onChange(fieldName, {
            min: (sliderValue as number[])[0] === 0 ? undefined : (sliderValue as number[])[0],
            max: (sliderValue as number[])[1] === 100 ? undefined : (sliderValue as number[])[1],
          })
        }}
        getAriaValueText={(value: number) => `${value} percent`}
        getAriaLabel={(i) => {
          if (i === 0) return `${ariaLabel} minimum`
          return `${ariaLabel} maximum`
        }}
        valueLabelDisplay="auto"
        marks={[
          {
            value: 0,
            label: '0%',
          },
          {
            value: 100,
            label: '100%',
          },
        ]}
      />
    </Box>
  </Box>
)

const FilterDemographics = ({ pctFirstGenerationStudents, onChange, enabled }: FilterDemographicsProps) => {
  const handleSliderChange = (fieldName: keyof FilterDemographicsProps, value: RangeFilterValue) => {
    onChange({ [fieldName]: value })
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={24}
    >
      <Typography
        component="div"
        variant="h6"
      >
        Student Demographics
      </Typography>
      <PremiumWrapper
        enabled={enabled}
        trackingIdPlacement="demographics-filter"
      >
        <DemographicSlider
          label="% First Generation"
          ariaLabel="Percent First Generation Range Slider"
          value={pctFirstGenerationStudents}
          fieldName="pctFirstGenerationStudents"
          onChange={handleSliderChange}
          enabled={enabled}
        />
      </PremiumWrapper>
    </Box>
  )
}

export default FilterDemographics
